import { render, staticRenderFns } from "./WrongAnswerBox.vue?vue&type=template&id=42fbf474&scoped=true&"
import script from "./WrongAnswerBox.vue?vue&type=script&lang=js&"
export * from "./WrongAnswerBox.vue?vue&type=script&lang=js&"
import style0 from "./WrongAnswerBox.vue?vue&type=style&index=0&id=42fbf474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fbf474",
  null
  
)

export default component.exports